// Types
import type { HeaderType } from "../../../types"

export const headerExample: HeaderType = {
  Customer_name: "Customer",
  Customer_code: "TM00001"
}

export const headerBlankExample: HeaderType = {
  Customer_name: "",
  Customer_code: ""
}